import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_WELL_KNOWN_LINKS_ROUTE_NAME = Symbol('admin.well-known-links');

export const TRANSLATION_GROUP_ADMIN_WELL_KNOWN_LINKS = Symbol('admin.well-known-links');

export const WELL_KNOWN_LINKS_LIST_QUERY_KEY = 'admin.well-known-links.list';
export const WELL_KNOWN_LINKS_LIST_API_URL = 'admin/click_domains_well_knowns/list';

export const WELL_KNOWN_DOMAINS_LIST_QUERY_KEY = 'admin.well-known.domains-list';
export const WELL_KNOWN_DOMAINS_LIST_API_URL = 'admin/click_domains_well_knowns/domains';

export const WELL_KNOWN_LINKS_SAVE_MUTATION_KEY = 'admin.well-known-links.save';
export const WELL_KNOWN_LINKS_SAVE_API_URL = 'admin/click_domains_well_knowns';

export const WELL_KNOWN_LINKS_UPDATE_DOMAINS_MUTATION_KEY = 'admin.well-known-links.update';
export const WELL_KNOWN_LINKS_UPDATE_DOMAINS_API_URL = 'admin/click_domains_well_knowns/:id/set_domains';

export const WELL_KNOWN_LINKS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.CLICK_DOMAINS_WELL_KNOWNS_SHOW),
  EDIT: new Permission(PermissionsList.admin.CLICK_DOMAINS_WELL_KNOWNS_EDIT),
};
